module.exports = __webpack_public_path__ + "static/media/argan.c0cbb543.png";